export default {"src":"/_next/static/media/clock.6a50cc43.svg","height":14,"width":13};